import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { ErrorGeneric, ErrorGenericV2, VfModal, GenericDetail } from "@vfit/shared/components";
import { useTracking } from "@vfit/shared/providers";
import { FullScreenModal, FullScreenModalExtended } from "@vfit/shared/atoms";
import { Severity } from "./interfaces";
export var ModalErrorWrapper = function() {
    var trackView = useTracking({
        event: [
            "starting_error_tracking"
        ],
        disableInitialTrack: true
    }).trackView;
    var initialDetail = {
        errorCode: "",
        message: "Si \xe8 verificato un errore.",
        title: "Ops",
        onClose: function() {},
        actionEvent: function() {},
        secondActionEvent: function() {},
        actionText: "",
        secondButtonText: "",
        severity: Severity.MEDIUM
    };
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = useState(initialDetail), modalDetail = ref1[0], setModalDetail = ref1[1];
    var onError = function(event) {
        var detail = event.detail;
        if (detail.disableTrack != true) {
            trackView(_object_spread({
                event_name: "page_error",
                event_category: "error",
                page_error: "".concat(detail.errorCode || "", "_").concat(detail.title, "_").concat(detail.message),
                page_error_code: detail.errorCode,
                page_type: "error page"
            }, detail.opts && _object_spread({}, detail.opts)));
        }
        if (!detail.options) {
            detail.options = {
                textAlign: "left",
                size: 18,
                lineHeight: 24
            };
        }
        setModalDetail(detail || modalDetail);
        setShowModal(!showModal);
    };
    useEffect(function() {
        if (typeof document !== "undefined") {
            document.addEventListener("errorServiceNotificationEvent", onError);
        }
        return function() {
            return document.removeEventListener("errorServiceNotificationEvent", onError);
        };
    }, []);
    var resetModalStatus = function() {
        setModalDetail(initialDetail);
        setShowModal(false);
    // modalDetail.actionEvent?.()
    };
    var handleCloseModal = function() {
        if (modalDetail.onClose) modalDetail.onClose();
        if (!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.disableCloseModalOnClickAction)) resetModalStatus();
    };
    var handleActionModal = function() {
        if (modalDetail.actionEvent) modalDetail.actionEvent();
        if (!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.disableCloseModalOnClickAction)) resetModalStatus();
    };
    var handleSecondActionModal = function() {
        if (modalDetail.secondActionEvent) modalDetail.secondActionEvent();
        if (!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.disableCloseModalOnClickAction)) resetModalStatus();
    };
    var handleActionModalExtended = useCallback(function() {
        var ref;
        modalDetail === null || modalDetail === void 0 ? void 0 : (ref = modalDetail.actionEvent) === null || ref === void 0 ? void 0 : ref.call(modalDetail);
        if (!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.keepOpenModalAfterAction)) {
            resetModalStatus();
        }
    }, [
        modalDetail,
        resetModalStatus
    ]);
    var handleSecondActionModalExtended = useCallback(function() {
        var ref;
        modalDetail === null || modalDetail === void 0 ? void 0 : (ref = modalDetail.secondActionEvent) === null || ref === void 0 ? void 0 : ref.call(modalDetail);
        if (!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.keepOpenModalAfterAction)) {
            resetModalStatus();
        }
    }, [
        modalDetail,
        resetModalStatus
    ]);
    if (modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.fullScreenExtended) {
        return /*#__PURE__*/ _jsx(FullScreenModalExtended, {
            show: true,
            showIcon: !!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.showIcon),
            showLogo: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.showLogo,
            onCloseModal: handleCloseModal,
            children: /*#__PURE__*/ _jsx(ErrorGenericV2, {
                title: (modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.title) || initialDetail.title,
                subtitle: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.subtitle,
                description: (modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.message) || initialDetail.message,
                descriptionOnTop: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.messageOnTop,
                action: handleActionModalExtended,
                actionText: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.actionText,
                icon: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.icon,
                customAction: handleSecondActionModalExtended,
                customActionText: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.secondButtonText,
                variant: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.variant,
                hideTitle: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.hideTitle
            })
        });
    }
    if (modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.fullscreen) {
        return /*#__PURE__*/ _jsx(FullScreenModal, {
            show: true,
            showIcon: !!(modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.showIcon),
            onCloseModal: handleCloseModal,
            children: /*#__PURE__*/ _jsx(ErrorGeneric, {
                title: (modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.title) || initialDetail.title,
                subtitle: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.subtitle,
                description: (modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.message) || initialDetail.message,
                action: handleCloseModal,
                actionText: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.actionText,
                icon: modalDetail === null || modalDetail === void 0 ? void 0 : modalDetail.icon
            })
        });
    }
    return /*#__PURE__*/ _jsx(VfModal, {
        isOpen: showModal,
        handleClose: handleCloseModal,
        children: /*#__PURE__*/ _jsx(GenericDetail, {
            title: modalDetail.title || initialDetail.title || "",
            description: modalDetail.message || initialDetail.message,
            secondButtonLabel: modalDetail.secondButtonText || "",
            secondButtonAction: handleSecondActionModal,
            submitButtonLabel: modalDetail.actionText,
            submitButtonAction: handleActionModal,
            event: modalDetail.event,
            event_label: modalDetail.event_label,
            options: modalDetail.options,
            opts: modalDetail.opts
        })
    });
};
